import React from 'react';
import { connect } from 'react-redux';

import EmailOptInTrigger from 'core/modules/EmailOptInTrigger/EmailOptInTrigger';
import RedirectToTargetLandingPage from 'core/modules/RedirectToTargetLandingPage/RedirectToTargetLandingPage';
import PageErrorBoundary from 'core/modules/ErrorBoundaries/PageErrorBoundary';
import ProductSearchResultsComponent from 'core/modules/ProductSearchResults/ProductSearchResults';

function ProductSearchResults() {
  return (
    <RedirectToTargetLandingPage>
      <PageErrorBoundary>
        <ProductSearchResultsComponent />
        <EmailOptInTrigger />
      </PageErrorBoundary>
    </RedirectToTargetLandingPage>
  );
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(ProductSearchResults);
